// extracted by mini-css-extract-plugin
module.exports = {"black_color":"#424242","gray_color":"#bdbdbd"};